import QACategoryEntity from "../../domain/entities/qa_category.entity";
import QAQuestionEntity from "../../domain/entities/qa_question.entity";
import QAResponseQuestionEntity from "../../domain/entities/qa_response_question.entity";
import QAResultEntity from "../../domain/entities/qa_result.entity";
import CallTranscriptionDto from "./call_transcription.dto";
import QACategoryDto from "./qa_category.dto";
import QAQuestionDto from "./qa_question.dto";
import QAResponseQuestionDto from "./qa_response_question.dto";

const fromJSON = (json: any): QAResultEntity => {
    const categories: QACategoryEntity[] = json.inputs.map((category: any) => QACategoryDto.fromJSON({...category, group: category.category_name, id: category.category_id, description: category.category_description}));
    //remove repeated categories
    const uniqueCategories:QACategoryEntity[] = [];

    categories.forEach((category) => {
        if (!uniqueCategories.find((uniqueCategory) => uniqueCategory.id == category.id)) {
            uniqueCategories.push(category);
        }
    });

    const questions: QAQuestionEntity[] = json.inputs.map((custom: any) => QAQuestionDto.fromJSON(custom));

    const responses:QAResponseQuestionEntity[] = json.output_result.analysis.customs.map((question:any)=> QAResponseQuestionDto.fromJSON({...question.response, question_id: question.id, id: question.id}));
    responses.forEach((response) => {
        const question = questions.find((question) => question.id == response.questionId);
        if (question) {
            question.response = response;
        }
    });

    uniqueCategories.forEach((category) => {
        category.questions = questions.filter((question) => question.categoryId === category.id);
    });


    return new QAResultEntity({
        id: json.job_id ?? "",
        audioUrl: json.output_result?.audios?.conversation_audio ?? "",
        categories: uniqueCategories,
        summary: json.output_result?.analysis?.call_summary?.summary ?? "holaaa",
        transcription: json.output_result?.segments != null ? CallTranscriptionDto.fromJSON(json.output_result?.segments) : {
            conversation: [],
        },
        humanAgent: json.human_agent, //TODO check
    });
}


export default {
    fromJSON,
};